/**
 * Outline SVG icon module.
 */
import * as React from "react";

/** Outline “paste crew” — clipboard with document + inward cue (matches folder icon style). */
const SvgClipboardPaste = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M38 35h-2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6M39 34v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2M44 40v3m0 0 2-2m-2 2-2-2M46 36h4"
    />
  </svg>
);
export default SvgClipboardPaste;
